export const tabs = [
  {
    destinationId: 1010394,
    destinationName: "Recife",
    destinationCompleteName: "Recife, Pernambuco, Brasil",
  },
  {
    destinationId: 1001872,
    destinationName: "Florianópolis",
    destinationCompleteName: "Florianópolis, Santa Catarina, Brasil",
  },
  {
    destinationId: 1010693,
    destinationName: "Salvador",
    destinationCompleteName: "Salvador, Bahia, Brasil",
  },
  {
    destinationId: 1010422,
    destinationName: "Rio de Janeiro",
    destinationCompleteName: "Rio de Janeiro, Rio de Janeiro, Brasil",
  },
];